<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part01"><a id="page_1"></a><strong>The Marquis de Sade<br/><em>Part One<br/>Critical</em></strong></h2>
<p class="noindent"><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?6d31a918